import { Action, createAction } from '@ngrx/store';
import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { filter, MonoTypeOperatorFunction, of, switchMap, take } from 'rxjs';
import { StaffDetailsActions } from '@cp/shared/data-access/+state/actions/staff-details.actions';
import { PayRatesActions } from '@cp/shared/data-access/+state/actions/pay-rates.actions';
import { WelcomePackActions } from '@cp/shared/data-access/+state/actions/welcome-pack.actions';
import { FirstShiftAppointmentStatusActions } from '@cp/shared/data-access/+state/actions/first-shift-appointment-status.actions';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { isAuthenticatedAndHealthy$ } from './helpers';

const OnInitEffectLoad = createAction(
  '[Authenticated & Healthy] On First Load',
);

@Injectable()
export class AuthenticatedHealthyEffects implements OnInitEffects {
  public loadStaffDetailsAfterAuthenticated$ = createEffect(() =>
    this._actions$.pipe(
      this._onEffectsInit(StaffDetailsActions.loadStaffDetails()),
    ),
  );

  public loadPayRatesAfterAuthenticated$ = createEffect(() =>
    this._actions$.pipe(this._onEffectsInit(PayRatesActions.loadPayRates())),
  );

  public loadWelcomePackAfterAuthentication$ = createEffect(() =>
    this._actions$.pipe(
      this._onEffectsInit(WelcomePackActions.loadWelcomePackStatus()),
    ),
  );

  public loadIsWelcomeCallAttendedAfterAuthentication$ = createEffect(() =>
    this._actions$.pipe(
      this._onEffectsInit(
        FirstShiftAppointmentStatusActions.loadFirstShiftAppointmentStatus(),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}

  public ngrxOnInitEffects(): Action {
    return OnInitEffectLoad();
  }

  private _onEffectsInit(
    actionToDispatch: Action,
  ): MonoTypeOperatorFunction<Action> {
    return (source) =>
      source.pipe(
        ofType(OnInitEffectLoad),
        isAuthenticatedAndHealthy$(),
        switchMap(() => of(actionToDispatch)),
        take(1),
      );
  }
}
